interface StepPhotosProps {
  urls: string[] | undefined;
}

/**
 * The photos saved on a step, as a row of thumbnails under its text. A video
 * saved among them is skipped (it has no thumbnail to draw), and nothing at all
 * is drawn for a step with none. They stay off paper: the printed card is
 * a one-sheet reference and its text is what a cook needs.
 */
export function StepPhotos({ urls }: StepPhotosProps) {
  const photos = (urls ?? []).filter((url) => !url.includes("video"));
  if (photos.length === 0) return null;
  return (
    <div className="mt-1 flex flex-wrap gap-2 print:hidden">
      {photos.map((url) => (
        <img
          key={url}
          src={url}
          alt=""
          loading="lazy"
          className="h-20 w-28 rounded-lg bg-(--color-surface-muted) object-cover"
        />
      ))}
    </div>
  );
}
